export interface IAdobeAnalyticsConfig {
    isDevMode?: boolean;
    clientDomain: string;
    developmentSource: string;
    productionSource: string;
    defaultPageLoadData: {
        pageInfo: {
            domain: string;
            subDomain: string;
            url: string;
            path: string;
            pageName: string;
            title: string;
            prefix: string;
        };
        category: {
            primaryCategory: string;
            subCategory1: string;
            subCategory2: string;
        };
        attributes: {
            country: string;
            language: string;
            template: string;
            promoMatsNumber: string;
            globalISI: string;
            type: string;
        };
        journey: {
            content: string;
            patient: string;
            messageBucket: string;
        };
        product: {
            name: string;
            franchise: string;
            indication: string;
            division: string;
            brand: string;
        };
        site: {
            type: string;
            experience: string;
            audience: string;
        };
        modal: {
            type: string;
            name: string;
            position: string;
            enabled: string;
            displayed: string;
        };
        search: {
            autoPosition: string;
            term: string;
            count: string;
            type: string;
            filterType: string;
            filterValue: string;
            filterCategory: string;
            sortByInit: string;
            origin: string;
            originURL: string;
        };
    };
    defaultUserData: IAdobeUserData[];
}

export interface IAdobeUserData {
    profile: [
        {
            id: {
                crmID: string;
                transID: string;
                abbvieCustomerID: string;
                hcpAccountID: string;
                npiID: string;
                dmpID: string;
                adobeID: string;
            };
            attributes: {
                status: string;
                type: string;
            };
        }
    ];
}
export interface IAdobePageLoad {
    pageInfo: {
        pageName: string;
        title: string;
        url?: string;
        path?: string;
        subdomain?: string;
    };
    category: {
        primaryCategory: string;
        subCategory1?: string;
        subCategory2?: string;
    };
    attributes: {
        country?: string;
        language?: string;
        type: string;
        globalISI?: string;
        promoMatsNumber?: string;
        template?: string;
    };
    journey: {
        content: string;
        patient?: string;
        messageBucket?: string;
    };
    product?: {
        brand?: string;
        name?: string;
        franchise?: string;
        indication?: string;
        division?: string;
    };
    site?: {
        type?: string;
        audience?: string;
        experience?: string;
    };
}

export enum InteractionType {
    Interaction,
    Link,
    Video,
    Form
}
export interface IAdobeInteraction {
    type?: InteractionType;
    link?: {
        name?: string;
        title?: string;
        type?: string;
        url?: string;
    };
    component?: {
        type?: string;
        l10title?: string;
        title?: string;
        name?: string;
        position?: string;
    };
    content?: {
        type?: string;
        title?: string;
        name?: string;
    };
    interaction?: {
        type?: string;
        name?: string;
    };
    form?: {
        name?: string;
        category?: string;
        subCategory?: string;
        fieldName?: string;
        fieldValue?: string;
        fieldValues?: string;
        stepName?: string;
        stepNumber?: string;
        errors?: string;
    };
    video?: {
        name?: string;
        id?: string;
        player?: string;
        length?: string;
        action?: string;
        playback?: string;
        type?: string;
    };
    journey?: {
        content?: string;
        patient?: string;
        messageBucket?: string;
    };
    mva?: {
        name?: string;
        tier?: string;
        type?: string;
        category?: string;
    };
    menu?: {
        location?: string;
        level?: string;
        label?: string;
        path?: string;
    };
}

export interface IAdobeLinkInteraction {
    type?: InteractionType;
    link?: {
        name?: string;
        title?: string;
        type?: string;
        url?: string;
    };
    component?: {
        type?: string;
        l10title?: string;
        title?: string;
        name?: string;
        position?: string;
    };
    content?: {
        type?: string;
        title?: string;
        name?: string;
    };
    interaction?: {
        type?: string;
        name?: string;
    };
    journey?: {
        content?: string;
        patient?: string;
        messageBucket?: string;
    };
    mva?: {
        name?: string;
        tier?: string;
        type?: string;
        category?: string;
    };
}

export interface IAdobeVideoInteraction {
    type?: InteractionType;
    video?: {
        name?: string;
        id?: string;
        player?: string;
        length?: string;
        action?: string;
        playback?: string;
        type?: string;
    };
    link?: {
        name?: string;
        title?: string;
        type?: string;
        url?: string;
    };
    component?: {
        type?: string;
        l10title?: string;
        title?: string;
        name?: string;
        position?: string;
    };
    content?: {
        type?: string;
        title?: string;
        name?: string;
    };
    interaction?: {
        type?: string;
        name?: string;
    };
    journey?: {
        content?: string;
        patient?: string;
        messageBucket?: string;
    };
    mva?: {
        name?: string;
        tier?: string;
        type?: string;
        category?: string;
    };
}

export interface IAdobeFormInteraction {
    type?: InteractionType;
    form?: {
        name?: string;
        category?: string;
        subCategory?: string;
        fieldName?: string;
        fieldValue?: string;
        fieldValues?: string;
        stepName?: string;
        stepNumber?: string;
        errors?: string;
    };
    content?: {
        type?: string;
        title?: string;
        name?: string;
    };
    interaction?: {
        type?: string;
        name?: string;
    };
    mva?: {
        name?: string;
        tier?: string;
        type?: string;
        category?: string;
    };
}
